import styles from "./HiviewerLoader.module.scss";
import { useEffect, useRef } from "react";
import type { CSSProperties } from "react";

type HiviewerLoaderProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
  color?: string;
  maxOpacity?: number;
  fadeStartMs?: number;
  fadeMs?: number;
  loopPauseMs?: number;
  repeat?: boolean;
  onCycleEnd?: () => void;
};

const letters = [
  "M41.1502 84.5251C41.8439 84.4759 42.3817 83.899 42.3817 83.2036V1.32443C42.3817 0.592967 41.7888 0 41.0573 0H29.0542C28.3227 0 27.7298 0.592967 27.7298 1.32443V35.852C27.7298 36.5835 27.1368 37.1764 26.4053 37.1764H15.9764C15.2449 37.1764 14.652 36.5835 14.652 35.852V1.32443C14.652 0.592967 14.059 0 13.3275 0H1.32443C0.592967 0 0 0.592971 0 1.32443V86.4226C0 87.2021 0.6699 87.813 1.44619 87.742C5.41379 87.3789 9.41168 87.0261 13.4389 86.6836C14.1247 86.6253 14.652 86.0518 14.652 85.3635V53.4238C14.652 52.6923 15.2449 52.0994 15.9764 52.0994H26.4053C27.1368 52.0994 27.7298 52.6923 27.7298 53.4238V84.0904C27.7298 84.8623 28.3871 85.4706 29.1567 85.4114C33.1284 85.106 37.1265 84.8105 41.1502 84.5251Z",
  "M68.9106 81.3045C68.9106 82.007 68.3619 82.5873 67.6605 82.6272C63.0071 82.8915 58.3834 83.1691 53.7907 83.4597C53.0275 83.5079 52.3817 82.9022 52.3817 82.1375V1.32443C52.3817 0.592969 52.9747 0 53.7061 0H67.5862C68.3176 0 68.9106 0.592967 68.9106 1.32443V81.3045Z",
  "M113.908 79.2808C113.81 79.9077 113.28 80.3766 112.646 80.3991C105.926 80.6373 99.2549 80.9025 92.6366 81.1942C91.9627 81.2239 91.3739 80.7427 91.2692 80.0763L78.927 1.53002C78.8007 0.726439 79.4219 0 80.2354 0H92.5142C93.1801 0 93.7424 0.494386 93.8277 1.15478L102.21 66.0514C102.25 66.3644 102.517 66.5988 102.833 66.5988C103.149 66.5988 103.416 66.3632 103.455 66.0491L111.597 1.15955C111.68 0.497033 112.244 0 112.911 0H124.817C125.631 0 126.252 0.726438 126.126 1.53002L113.908 79.2808Z",
  "M152.035 77.9621C152.035 78.6845 151.456 79.2735 150.734 79.2867C146.304 79.3674 141.892 79.4598 137.498 79.5636C136.755 79.5812 136.142 78.9832 136.142 78.2392V1.32443C136.142 0.592964 136.735 0 137.466 0H150.711C151.442 0 152.035 0.592967 152.035 1.32443V77.9621Z",
  "M193.821 78.2368C193.821 78.5879 193.537 78.8724 193.186 78.8724C183.174 78.8724 173.234 78.9316 163.376 79.0481C162.638 79.0568 162.035 78.4613 162.035 77.7234V1.32443C162.035 0.592967 162.628 0 163.36 0H192.497C193.229 0 193.821 0.592969 193.821 1.32443V11.2653C193.821 11.9968 193.229 12.5898 192.497 12.5898H177.397C176.665 12.5898 176.072 13.1827 176.072 13.9142V31.7093C176.072 32.4408 176.665 33.0337 177.397 33.0337H190.293C191.024 33.0337 191.617 33.6267 191.617 34.3582V44.2991C191.617 45.0306 191.024 45.6235 190.293 45.6235H177.397C176.665 45.6235 176.072 46.2165 176.072 46.9479V65.5516C176.072 66.283 176.665 66.876 177.397 66.876H192.497C193.229 66.876 193.821 67.469 193.821 68.2004V78.2368Z",
  "M233.712 78.0633C233.632 78.7386 233.054 79.2436 232.374 79.2321C226.232 79.1279 220.057 79.046 213.851 78.9868C213.182 78.9805 212.623 78.4769 212.547 77.8124L203.83 1.47468C203.74 0.688804 204.355 0 205.146 0H217.104C217.795 0 218.369 0.530837 218.424 1.21939L223.582 66.0525C223.601 66.2936 223.803 66.4794 224.044 66.4794C224.28 66.4794 224.478 66.3029 224.505 66.069L232.015 1.17218C232.093 0.504078 232.658 0 233.331 0H248.646C249.316 0 249.881 0.501455 249.961 1.16748L257.706 66.0707C257.734 66.3039 257.932 66.4794 258.167 66.4794C258.409 66.4794 258.611 66.2926 258.629 66.0508L263.552 1.22414C263.605 0.533568 264.18 0 264.873 0H276.346C277.137 0 277.751 0.688806 277.661 1.47468L268.82 78.9054C268.742 79.5905 268.151 80.1009 267.462 80.0792C261.378 79.8881 255.255 79.7192 249.096 79.5727C248.438 79.557 247.891 79.0604 247.812 78.4066L241.089 22.5573C241.065 22.3532 240.892 22.1996 240.686 22.1996C240.48 22.1996 240.307 22.3536 240.283 22.5581L233.712 78.0633Z",
  "M322.105 81.2266C322.105 81.9876 321.466 82.592 320.706 82.5493C310.261 81.9626 299.668 81.4426 288.94 80.9919C288.23 80.9621 287.67 80.3784 287.67 79.6683V1.32443C287.67 0.592967 288.263 0 288.994 0H320.781C321.512 0 322.105 0.592968 322.105 1.32443V12.1047C322.105 12.8361 321.512 13.4291 320.781 13.4291H304.201C303.47 13.4291 302.877 14.0221 302.877 14.7535V33.9116C302.877 34.643 303.47 35.236 304.201 35.236H318.393C319.124 35.236 319.717 35.829 319.717 36.5604V47.3407C319.717 48.0721 319.124 48.6651 318.393 48.6651H304.201C303.47 48.6651 302.877 49.2581 302.877 49.9895V70.01C302.877 70.7414 303.47 71.3344 304.201 71.3344H320.781C321.512 71.3344 322.105 71.9274 322.105 72.6588V81.2266Z",
  "M347.24 83.0088C347.24 83.7768 346.589 84.3838 345.823 84.3305C341.691 84.043 337.531 83.7661 333.346 83.5001C332.649 83.4557 332.105 82.877 332.105 82.1779V1.32443C332.105 0.592967 332.698 0 333.43 0H355.746C361.333 0 365.503 1.05877 368.255 3.17632C371.09 5.29387 372.966 8.30078 373.884 12.1971C374.801 16.0934 375.26 21.3872 375.26 28.0787C375.26 34.6854 374.801 39.9793 373.884 43.9603C373.046 47.5175 371.34 50.298 368.765 52.302C368.321 52.6476 368.101 53.2182 368.245 53.7622L376.478 84.9213C376.712 85.807 375.997 86.6572 375.084 86.5802C370.801 86.2187 366.485 85.869 362.137 85.5312C361.561 85.4864 361.08 85.0737 360.949 84.5111L354.609 57.3082C354.469 56.7086 353.935 56.2844 353.319 56.2844H348.565C347.833 56.2844 347.24 56.8774 347.24 57.6088V83.0088ZM357.873 41.8004C356.955 42.478 355.413 42.8168 353.245 42.8168H348.565C347.833 42.8168 347.24 42.2238 347.24 41.4924V15.1732C347.24 14.4417 347.833 13.8488 348.565 13.8488H353.245C355.413 13.8488 356.955 14.2299 357.873 14.9922C358.873 15.6698 359.499 16.9827 359.749 18.9309C360.083 20.879 360.249 24.013 360.249 28.3328C360.249 32.6526 360.083 35.7865 359.749 37.7347C359.499 39.6828 358.873 41.0381 357.873 41.8004Z",
];

const LETTER_STEP_MS = 60;
const DROP_MS = 420;
const DEFAULT_FADE_MS = 324;
const DEFAULT_FADE_START_MS = letters.length * LETTER_STEP_MS + DROP_MS;

const easeInQuad = (value: number) => value * value;

const createCubicBezier = (x1: number, y1: number, x2: number, y2: number) => {
  const sample = (a1: number, a2: number, value: number) => {
    const inverse = 1 - value;

    return 3 * inverse * inverse * value * a1 + 3 * inverse * value * value * a2 + value * value * value;
  };

  const derivative = (a1: number, a2: number, value: number) =>
    3 * (1 - value) * (1 - value) * a1 +
    6 * (1 - value) * value * (a2 - a1) +
    3 * value * value * (1 - a2);

  return (progress: number) => {
    let value = progress;

    for (let i = 0; i < 5; i += 1) {
      const x = sample(x1, x2, value) - progress;
      const dx = derivative(x1, x2, value);

      if (Math.abs(x) < 0.00001 || dx === 0) {
        break;
      }

      value -= x / dx;
      value = Math.min(1, Math.max(0, value));
    }

    return sample(y1, y2, value);
  };
};

const dropEase = createCubicBezier(0.22, 1.5, 0.36, 1);

const applyLetterState = (
  letter: SVGPathElement,
  opacity: number,
  translateY: number,
  scaleY: number,
  scaleX: number
) => {
  letter.style.opacity = `${opacity}`;
  letter.style.transform = `translateY(${translateY}px) scaleY(${scaleY}) scaleX(${scaleX})`;
};

const toCssSize = (value: number | string) => (typeof value === "number" ? `${value}px` : value);

const HiviewerLoader = ({
  className,
  width = 120,
  height = 28,
  color = "#fafafa",
  maxOpacity = 0.1,
  fadeStartMs = DEFAULT_FADE_START_MS,
  fadeMs = DEFAULT_FADE_MS,
  loopPauseMs = 0,
  repeat = true,
  onCycleEnd,
}: HiviewerLoaderProps) => {
  const letterRefs = useRef<Array<SVGPathElement | null>>([]);

  useEffect(() => {
    const animatedLetters = letterRefs.current.filter(Boolean) as SVGPathElement[];

    if (!animatedLetters.length) {
      return;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      animatedLetters.forEach((letter) => {
        letter.style.opacity = `${maxOpacity}`;
        letter.style.transform = "none";
      });

      if (!repeat && onCycleEnd) {
        const timeout = window.setTimeout(onCycleEnd, 900);

        return () => window.clearTimeout(timeout);
      }

      return;
    }

    let animationFrame = 0;
    let startedAt = 0;
    let completed = false;
    const loopMs = fadeStartMs + fadeMs + loopPauseMs;

    const render = (timestamp: number) => {
      if (!startedAt) {
        startedAt = timestamp;
      }

      const elapsed = timestamp - startedAt;
      const loopTime = repeat ? elapsed % loopMs : Math.min(elapsed, fadeStartMs + fadeMs);

      animatedLetters.forEach((letter, index) => {
        const dropStart = index * LETTER_STEP_MS;
        const dropEnd = dropStart + DROP_MS;

        if (loopTime < dropStart) {
          applyLetterState(letter, 0, -20, 0.4, 1.1);

          return;
        }

        if (loopTime < dropEnd) {
          const progress = (loopTime - dropStart) / DROP_MS;
          const easedProgress = dropEase(progress);

          applyLetterState(
            letter,
            maxOpacity * easedProgress,
            -20 + 20 * easedProgress,
            0.4 + 0.6 * easedProgress,
            1.1 - 0.1 * easedProgress
          );

          return;
        }

        if (loopTime < fadeStartMs) {
          applyLetterState(letter, maxOpacity, 0, 1, 1);

          return;
        }

        const fadeProgress = easeInQuad((loopTime - fadeStartMs) / fadeMs);

        applyLetterState(letter, maxOpacity * (1 - fadeProgress), 8 * fadeProgress, 1, 1);
      });

      if (!repeat && elapsed >= fadeStartMs + fadeMs) {
        if (!completed) {
          completed = true;
          onCycleEnd?.();
        }

        return;
      }

      animationFrame = requestAnimationFrame(render);
    };

    animationFrame = requestAnimationFrame(render);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [fadeMs, fadeStartMs, loopPauseMs, maxOpacity, onCycleEnd, repeat]);

  return (
    <div
      className={`${styles.wrapper} ${className || ""}`}
      style={
        {
          "--hiviewer-loader-width": toCssSize(width),
          "--hiviewer-loader-height": toCssSize(height),
          "--hiviewer-loader-color": color,
        } as CSSProperties
      }
      role="status"
      aria-label="Loading"
    >
      <svg className={styles.logo} viewBox="0 0 377 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        {letters.map((path, index) => (
          <path
            key={index}
            ref={(element) => {
              letterRefs.current[index] = element;
            }}
            className={styles.letter}
            d={path}
            fillRule={index === 7 ? "evenodd" : undefined}
            clipRule={index === 7 ? "evenodd" : undefined}
          />
        ))}
      </svg>
    </div>
  );
};

export default HiviewerLoader;
